import { REACT_APP_GOOGLE_MAPS_API_KEY } from '@common/utils/keys/googleMaps';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useJsApiLoader } from '@react-google-maps/api';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import { reducerPaths } from './app/reducerPaths';
import { AlertDialog } from './components/custom/AlertDialog';
import ProtectedRoute from './components/custom/ProtectedRoutes';
import AuthLayout from './pages/AuthPages/AuthLayout';
import Dashboard from './pages/Dashboard/Dashboard';
import { routes } from './utils/constants/routes';
import { useLazyGetProfileDetailsQuery } from './toolkit/auth/authApi';

function App() {
  const libraries = React.useMemo(() => {
    return ['places'];
  }, []);

  // useSelector start...
  const auth = useSelector((store) => store[reducerPaths.auth]);
  // useSelector end...

  const [getProfileDetailsApiHandler, getProfileDetailsApiData] = useLazyGetProfileDetailsQuery();

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: REACT_APP_GOOGLE_MAPS_API_KEY,
    id: 'google-maps',
    libraries,
  });

  useEffect(() => {
    if (
      process.env.NODE_ENV === 'production' &&
      process.env.REACT_APP_ENV === 'production' && // Only force HTTPS in production
      window.location.protocol !== 'https:'
    ) {
      window.location.href = `https://${window.location.host}${window.location.pathname}`;
    }
  }, []);

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      (async () => {
        await getProfileDetailsApiHandler();
      })();
    }, 10000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Router>
        <div className="App">
          <Routes>
            {/* {auth?.token ? (
              <Route path={routes.dashboard} element={<Dashboard />} />
            ) : (
              <Route path={routes.dashboard} element={<Navigate to={routes.authSignin} />} />
            )}           */}
            {!auth?.token ? (
              <Route path={routes.auth} element={<AuthLayout />} />
            ) : (
              <Route path={routes.auth} element={<Navigate to={routes.dashboardNavigation} />} />
            )}

            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route path={routes.dashboard} element={<Dashboard />} />
              {/* <Route
                path={routes.carEstimate}
                element={<CarEstimateAndAuctionForm />}
              /> */}
            </Route>
            {/* <Route path="/" element={<SignUp />} /> */}
            {/* <Route path="/dealerin" element={<DealerIn />} />
            <Route path="/verification" element={<DealerVerification />} />
            <Route path="/SellerNav" element={<SellerNav />} />
            <Route path="/open-bid/" element={<OpenBid />} />
            <Route path="/car-details/:Vehicle_Id" element={<CarDetails />} />
            <Route path="/winner-bid" element={<WinnerBid />} />
            <Route path="/expired-cars" element={<ExpiredCars />} />
            <Route path="/winner-car-bid/:Vehicle_Id" element={<WinnerCarBid />} />
            <Route path="/expired-car-details/:Vehicle_Id" element={<ExpiredCarDetails />} />
            <Route path="/nagition-cars" element={<NagitionCars />} />
            <Route path="/nagition-cars-details/:Vehicle_Id" element={<NagitionCarDetails />} />
            <Route path="/nagition-bids/:Vehicle_Id" element={<NagitionBids />} /> 
            <Route path="/nagition-bid-pop" element={<NagitionBidPopUp />} /> 
            <Route path="/future-cars" element={<FutureCars />} /> 
            <Route path="/future-car-details/:Vehicle_Id" element={<FutureCarDetails />} />  
            <Route path="/bid-history/:Vehicle_Id" element={<BidHistory />} />
            <Route path="/watchlist" element={<WatchList />} />
            <Route path="/car-details-expire/:Vehicle_Id" element={<SimpleCarDetails />} />
            <Route path="/oauth/callback" element={<OAuthCallback />} />
            <Route path="/dealer-bos/:Vehicle_Id" element={<DealerBos />} />
            <Route path="/midware/:Vehicle_Id/:Dealer_Id" element={<Midware />} /> */}

            {auth?.token ? (
              <Route path="*" element={<Navigate to={routes.dashboardNavigation} />} />
            ) : (
              <Route path="*" element={<Navigate to={routes.authSignin} />} />
            )}
          </Routes>

          <AlertDialog />
        </div>
      </Router>
    </LocalizationProvider>
  );
}

export default App;
